import {
    Box,
    Button,
    Card,
    CardBody,
    Checkbox,
    Flex,
    Grid,
    IconButton,
    Popover,
    PopoverArrow,
    PopoverBody,
    PopoverCloseButton,
    PopoverContent,
    PopoverTrigger,
    Portal,
    SimpleGrid,
    Table,
    TableContainer,
    Tag,
    Tbody,
    Td,
    Text,
    Th,
    Thead,
    Tooltip,
    Tr,
    useBreakpointValue,
    useDisclosure,
    VStack,
} from "@chakra-ui/react";
import CommonModal from "components/common/CommonModal/CommonModal";
import CustomDateRangeMobile from "components/common/CustomDateRangeMobile/CustomDateRangeMobile";
import CustomDateRangePicker from "components/common/CustomDateRangePicker/CustomDateRangePicker";
import { Paginationlimit } from "components/common/functions/variable";
import Pagination from "components/common/Pagination/Pagination";
import TableLoader from "components/common/TableLoader/TableLoader";
import { useContext, useEffect, useState } from "react";
import { HiOutlineFilter, HiOutlineRefresh } from "react-icons/hi";
import { RiFileExcel2Line } from "react-icons/ri";
import { appRequest } from "routes";
import { formatDateTime } from "utils/dateUtils/dateUtils";
import * as XLSX from "xlsx";
import CustomSelect from "../../common/CustomSelect/CustomSelect";
import { formatDateYYYYMMDD } from "App/DMRC/FortamDate";
import SdkOrderDetails from "../../Dashboards/OrderDashboard/SdkOrderDetails";
import SdkOrderCard from "./OrderCardView/SdkOrderCard";
import CustomSelect2 from "../../common/CustomSelect/CustomSelect2";
import { FaRegCheckCircle, FaRegClock, FaRegMoneyBillAlt, FaRegTimesCircle } from "react-icons/fa";
import DashboardCard from "../../DashboardCard/DashboardCard";
import { MdOutlineCancel, MdOutlineUndo } from "react-icons/md";

const SdkOrderTable = () => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [data, setData] = useState<any[]>([]);
    const [statuses, setStatuses] = useState<any[]>([]);
    const [orderData, setOrderData] = useState<any>({});
    const [loading, setLoading] = useState(false);
    const [filterStatus, setFilterStatus] = useState<any>("");
    const initialDateRange = {
        startDate: new Date(new Date().setDate(new Date().getDate() - 7)),
        endDate: new Date(),
        key: "selection",
    };

    const [dateRange, setDateRange] = useState<any>(initialDateRange);
    const { startDate, endDate } = dateRange;
    const drawerWidth = useBreakpointValue({
        base: "100vw",
        md: "80vw",
        lg: "55vw",
    });
    const [cities, setCities] = useState<any>([]);
    const [cityFilter, setCityFilter] = useState<any>("");
    const [cityCode, setCityCode] = useState<any>("");
    const [cityName, setCityName] = useState<any>("");
    const isMobileView = useBreakpointValue({ base: true, md: false });

    const handleOrderDetails = (data: any) => {
        setOrderData(data);
        setIsDrawerOpen(true);
    };

    const getCities = async () => {
        try {
            setLoading(true);
            const response: any = await appRequest("metro", "allCities", {});

            if (response.status === "success") {
                setCities(response?.cities || []);
                // console.log("get cities response", cities);
            }
        } catch (error: any) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    const formattedStartDate = formatDateYYYYMMDD(startDate); // Format start date
    const formattedEndDate = formatDateYYYYMMDD(endDate); // Format end date

    const getOrders = async (currentP?: number, isDownload?: boolean) => {
        try {
            setLoading(true);
            let page = currentP ? currentP : currentPage;
            let limit = Paginationlimit;
            let status = filterStatus ? filterStatus : "";
            let startDate = formattedStartDate;
            let endDate = formattedEndDate;

            const request: any = {
                limit,
                page,
                status,
                cityCode,
                startDate,
                endDate
            };

            console.log("order table request", request);
            const response: any = await appRequest("metro", "sdkOrders", request);

            if (response.status === "success") {
                // setTotalPages(response?.totalPages || 0);
                setData(response?.orders || []);
                setStatuses(response?.statuses || []);
                console.log("sdk order table data", response)
                setTotalPages(response?.totalPages || 0);
            }
        } catch (err: any) {
            console.error("Error fetching data:", err);
        } finally {
            setLoading(false);
        }
    };

    const getAllOrders = async () => {
        try {
            let allOrders: any[] = [];
            let page = 1;
            let hasMore = true;

            while (hasMore) {
                const response: any = await appRequest("metro", "sdkOrders", {
                    page,
                    limit: 50,
                    status: filterStatus,
                    cityCode,
                    startDate: formattedStartDate,
                    endDate: formattedEndDate,
                });

                if (response.status === "success") {
                    allOrders = [...allOrders, ...(response.orders || [])];

                    if (page >= response.totalPages) {
                        hasMore = false;
                    } else {
                        page++;
                    }
                } else {
                    hasMore = false;
                }
            }

            return allOrders;
        } catch (err) {
            console.error("Error fetching all data:", err);
            return [];
        }
    };

    const handleDownloadExcel = async () => {
        try {
            const allData = await getAllOrders();
            if (allData.length > 0) {
                exportToExcel(allData);
            } else {
                console.warn("No data available to export");
            }
        } catch (err) {
            console.error("Error downloading Excel:", err);
        }
    };

    const exportToExcel = async (data: any) => {
        if (!data || data.length === 0) {
            console.error("No data available for export");
            return; // Stop if data is not available
        }

        const filteredData = data.map((txn: any) => ({
            Date: formatDateTime(txn?.createdAt) || "N/A",
            TransactionId: txn?._id || "N/A",
            OrderTransactionIds:
                [...new Set(txn?.orders?.map((o: any) => o?.transaction_id))].join(", ") ||
                "N/A",
            UserName: txn?.user?.name || txn?.billingDetails?.name || "N/A",
            UserNumber: txn?.user?.moNumber || txn?.billingDetails?.phone || "N/A",
            StartStation: txn?.startStation || "N/A",
            DestinationStation: txn?.destinationStation || "N/A",
            Providers:
                [...new Set(txn?.orders?.map((o: any) => o.providerName))].join(", ") ||
                "N/A",
            NumberOfTickets: txn?.ticketCount || 0,
            Price_Rs: txn?.totalPrice || 0,
            Status: txn?.status || "Unknown",
        }));

        const worksheet = XLSX.utils.json_to_sheet(filteredData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");

        // Download the file
        const currentDate = new Date();
        const formattedDate = currentDate.toISOString().split("T")[0];
        const filename = `orders_report_${formattedDate}.xlsx`;
        XLSX.writeFile(workbook, filename);
    };

    useEffect(() => {
        getOrders();
    }, [
        currentPage,
        filterStatus,
        endDate,
        cityFilter,
        cityCode
    ]);

    useEffect(() => {
        getCities();
    }, []);

    const cityNames = cities.map((city: any) => ({
        value: city?._id,
        label: city?.name,
        cityCode: city?.cityCode,
    }));

    const handleCityFilterChange = (e: any) => {
        if (e && e.value) {
            const selectedCity = {
                id: e.value, // city ID
                cityCode: e.cityCode, // city code
                name: e.label, //  city name
            };
            console.log(selectedCity)
            setCityFilter(selectedCity.id);
            setCityCode(selectedCity.cityCode);
            setCityName(selectedCity.name);
            localStorage.setItem("selectedCity", JSON.stringify(selectedCity));
        } else {
            setCityFilter(""); // or any default value you'd like to set
            setCityCode(""); // or any default value you'd like to set
            setCityName(""); // or any default value you'd like to set
            localStorage.removeItem("selectedCity");
        }
    };

    const handlePageChange = (page: any) => {
        setCurrentPage(page.selected + 1);
    };

    const handleStartDateChange = (startDate: Date) => {
        setDateRange((prevDateRange: any) => ({
            ...prevDateRange,
            startDate: new Date(startDate),
        }));
    };

    const handleEndDateChange = (endDate: Date) => {
        setDateRange((prevDateRange: any) => ({
            ...prevDateRange,
            endDate: new Date(endDate),
        }));
    };

    const handleDateChange = (item: any) => {
        const newStartDate = item.selection.startDate.toISOString();
        const newEndDate = item.selection.endDate.toISOString();
        handleStartDateChange(newStartDate);
        handleEndDateChange(newEndDate);
    };

    const handleStatusChange = (e: any) => {
        if (e && e.value) {
            setFilterStatus(e.value);
        } else {
            setFilterStatus(""); // or any default value you'd like to set
        }
    };

    const filterStatusOptions = [
        { value: "PAYMENT_INITIATED", label: "Payment Initiated" },
        { value: "PAYMENT_FAILED", label: "Payment Failed" },
        { value: "SUCCESSFUL", label: "Successful" },
        { value: "REFUNDED", label: "Refunded" },
        { value: "CANCEL_INITIATED", label: "Cancel Initiated" },
        { value: "CANCELLED", label: "Cancelled" },
    ];

    const handleRefreshAllData = () => {
        setDateRange(initialDateRange);
        setFilterStatus("");
        setCityFilter("");
        setCityCode("");
    };

    const fixedStatusCards = [
        {
            key: "PAYMENT_INITIATED",
            title: "Payment Initiated",
            icon: FaRegClock,
            iconColor: "orange.400",
            iconBgColor: "orange.50",
        },
        {
            key: "PAYMENT_FAILED",
            title: "Payment Failed",
            icon: FaRegTimesCircle,
            iconColor: "red.400",
            iconBgColor: "red.50",
        },
        {
            key: "SUCCESSFUL",
            title: "Successful",
            icon: FaRegCheckCircle,
            iconColor: "green.400",
            iconBgColor: "green.50",
        },
        {
            key: "REFUNDED",
            title: "Refunded",
            icon: FaRegMoneyBillAlt,
            iconColor: "green.400",
            iconBgColor: "green.50",
        },
        {
            key: "CANCEL_INITIATED",
            title: "Cancel Initiated",
            icon: FaRegClock,
            iconColor: "orange.400",
            iconBgColor: "orange.50",
        },
        {
            key: "CANCELLED",
            title: "Cancelled",
            icon: MdOutlineCancel,
            iconColor: "red.400",
            iconBgColor: "red.50",
        },
    ];


    return (
        <>
            {/* Status summary cards */}
            <SimpleGrid columns={{ base: 2, md: 3, lg: 6 }} spacing={4} mb={6}>
                {fixedStatusCards.map((card) => {
                    const count =
                        statuses.find((s: any) => s.status === card.key)?.count || 0;
                    return (
                        <DashboardCard
                            key={card.key}
                            title={card.title}
                            value={count}
                            icon={card.icon}
                            iconColor={card.iconColor}
                            iconBgColor={card.iconBgColor}
                            showTrend={false}
                            iconBoxSize={{ base: 10, md: 12, lg: 10 }}
                        />
                    );
                })}
            </SimpleGrid>

            <Box
                p={5}
                rounded={"lg"}
                bg={"white"}
                shadow={"rgb(0 0 0 / 20%) 0px 0px 11px"}
            >
                <Flex
                    justify={"space-between"}
                    mb={2}
                    direction={{ base: "column", md: "row" }}
                >
                    <Text fontWeight={700} fontSize={"xl"} color={"teal.400"} mb={2}>
                        All Orders
                    </Text>

                    <Flex gap={2} direction={{ base: "column", md: "row" }}>
                        <Flex align="center" gap={2} mb={{ base: 2, lg: 0 }}>
                            {cityFilter ? (
                                <Text fontWeight="bold" fontSize="md" color="teal.600">
                                    City:{cityName}
                                </Text>
                            ) : (
                                <Text fontWeight="bold" fontSize="md" color="gray.500">
                                    No City Selected
                                </Text>
                            )}
                        </Flex>
                        {/* <Flex gap={2} justify={"end"}> */}
                        <Box display={{ base: "none", lg: "block" }}>
                            <CustomDateRangePicker
                                dateFrom={dateRange.startDate && new Date(dateRange.startDate)}
                                dateTo={dateRange.endDate && new Date(dateRange.endDate)}
                                onStartDateChange={handleStartDateChange}
                                onEndDateChange={handleEndDateChange}
                                months={2}
                            />
                        </Box>
                        <Box display={{ base: "block", lg: "none" }}>
                            <CustomDateRangeMobile
                                range={[dateRange]}
                                onChange={handleDateChange}
                            />
                        </Box>
                        <Grid templateColumns="1fr 1fr" gap={2} alignItems={'center'}>
                            <Tooltip label="Refresh" hasArrow>
                                <IconButton
                                    aria-label="Refresh"
                                    icon={<HiOutlineRefresh />}
                                    colorScheme="teal"
                                    variant="outline"
                                    borderWidth={2}
                                    _hover={{ bg: "teal.100" }}
                                    onClick={handleRefreshAllData}
                                    size={{ base: "sm", md: "md" }}
                                />
                            </Tooltip>
                            <Popover>
                                <PopoverTrigger>
                                    <IconButton
                                        aria-label="Filter"
                                        colorScheme="teal"
                                        icon={<HiOutlineFilter />}
                                        size={{ base: "sm", md: "md" }}
                                    />
                                </PopoverTrigger>
                                <Portal>
                                    <PopoverContent shadow={"lg"} borderWidth={2}>
                                        <PopoverArrow />
                                        <PopoverCloseButton />
                                        <PopoverBody p={5}>
                                            <VStack spacing={6} mt={2}>
                                                <CustomSelect2
                                                    options={cityNames}
                                                    label={"Filter By City"}
                                                    onChange={handleCityFilterChange}
                                                    value={
                                                        cityFilter
                                                            ? cityNames.find((c: any) => c.value === cityFilter)
                                                            : null
                                                    }
                                                />
                                                <CustomSelect2
                                                    options={filterStatusOptions}
                                                    label={"Filter By Status"}
                                                    onChange={handleStatusChange}
                                                    value={
                                                        filterStatus
                                                            ? filterStatusOptions.find((s) => s.value === filterStatus)
                                                            : null
                                                    }
                                                />
                                                {/* <Button
                                                    w={"100%"}
                                                    colorScheme="teal"
                                                    variant={"outline"}
                                                    onClick={handleDownloadExcel}
                                                    leftIcon={
                                                        <RiFileExcel2Line
                                                            fontSize={"20px"}
                                                            color="green.400"
                                                        />
                                                    }
                                                >
                                                    Download Excel
                                                </Button> */}
                                            </VStack>
                                        </PopoverBody>
                                    </PopoverContent>
                                </Portal>
                            </Popover>
                        </Grid>
                    </Flex>
                </Flex>

                {isMobileView ? (
                    <>
                        {/* <OrderCard
                        data={data}
                        selectedValues={selectedValues}
                        setOpenCancelModal={setOpenCancelModal}
                        setSelectedValues={setSelectedValues}
                        handleTransactionId={handleTransactionId}
                        findProviderNameByBapId={findProviderNameByBapId}
                    /> */}
                        <SdkOrderCard
                            data={data}
                        />
                    </>
                ) : (
                    <>
                        <TableContainer className="customScrollBar" pb={2}>
                            <Table>
                                <Thead>
                                    <Tr>
                                        <Th>Transaction ID</Th>
                                        <Th>Order Transaction ID</Th>
                                        <Th>User Name</Th>
                                        <Th>User Number</Th>
                                        <Th>Start</Th>
                                        <Th>Destination</Th>
                                        <Th>Providers</Th>
                                        <Th textAlign="center">Tickets</Th>
                                        <Th textAlign="end">Total Fare</Th>
                                        <Th>Date</Th>
                                        <Th>Status</Th>
                                    </Tr>
                                </Thead>
                                <TableLoader
                                    noDataText="No Orders Available"
                                    show={data?.length}
                                    loader={loading}
                                >
                                    <Tbody>
                                        {data?.map((txn, index) => {
                                            console.log('txn------>', txn)
                                            const providers = txn?.orders?.map((o: any) => o.providerName) || [];
                                            const providerLabel =
                                                [...new Set(providers)].length > 1
                                                    ? "Multiple"
                                                    : providers[0] || "N/A";

                                            return (
                                                <Tr key={txn._id} _hover={{ bg: "gray.100" }}>
                                                    <Td>
                                                        <Flex gap={2} align="flex-end">
                                                            <Tooltip label={txn?._id} hasArrow>
                                                                <Text
                                                                    color="blue.500"
                                                                    fontWeight={500}
                                                                    cursor="pointer"
                                                                    isTruncated
                                                                    maxW="12rem"
                                                                    onClick={() => handleOrderDetails(txn)}
                                                                >
                                                                    {txn?._id}
                                                                </Text>
                                                            </Tooltip>
                                                        </Flex>
                                                    </Td>

                                                    {/* Order Transaction Id */}
                                                    <Td>
                                                        {txn?.orders?.length ? (
                                                            <Flex direction="column" gap={1}>
                                                                {txn.orders
                                                                    .map((order: any) => order?.transaction_id)
                                                                    .filter(Boolean)
                                                                    .map((id: any, index: any) => (
                                                                        <Tooltip key={index} label={id} hasArrow>
                                                                            <Text
                                                                                isTruncated
                                                                                maxW="12rem"
                                                                                whiteSpace="nowrap"
                                                                                overflow="hidden"
                                                                                textOverflow="ellipsis"
                                                                            >
                                                                                {id}
                                                                            </Text>
                                                                        </Tooltip>
                                                                    ))}
                                                            </Flex>
                                                        ) : (
                                                            "N/A"
                                                        )}
                                                    </Td>

                                                    {/* User Name */}
                                                    <Td>{txn?.user?.name || txn?.billingDetails?.name || "N/A"}</Td>

                                                    {/* User Number */}
                                                    <Td>{txn?.user?.moNumber || txn?.billingDetails?.phone || "N/A"}</Td>

                                                    {/* Stations */}
                                                    <Td>{txn?.startStation || "N/A"}</Td>
                                                    <Td>{txn?.destinationStation || "N/A"}</Td>

                                                    {/* Providers */}
                                                    <Td>{providerLabel}</Td>

                                                    {/* Tickets & Price */}
                                                    <Td textAlign="center">{txn?.ticketCount || 0}</Td>
                                                    <Td textAlign="end">₹ {txn?.totalPrice || 0}</Td>

                                                    {/* Date */}
                                                    <Td>{formatDateTime(txn?.createdAt, "DD-MM-YYYY")}</Td>

                                                    {/* Status */}
                                                    <Td>
                                                        <Tag
                                                            size="sm"
                                                            colorScheme={
                                                                txn?.status === "SUCCESSFUL"
                                                                    ? "green"
                                                                    : txn?.status === "REFUNDED"
                                                                        ? "green"
                                                                        : txn?.status === "PAYMENT_VERIFIED"
                                                                            ? "green"
                                                                            : txn?.status === "PAYMENT_FAILED"
                                                                                ? "red"
                                                                                : txn?.status === "CANCELLED"
                                                                                    ? "red"
                                                                                    : txn?.status === "PAYMENT_INITIATED"
                                                                                        ? "orange"
                                                                                        : txn?.status === "CANCEL_INITIATED"
                                                                                            ? "orange"
                                                                                            : "blue"
                                                            }
                                                        >
                                                            {txn?.status}
                                                        </Tag>
                                                    </Td>
                                                </Tr>
                                            );
                                        })}
                                    </Tbody>


                                </TableLoader>
                            </Table>
                        </TableContainer>
                        <Pagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            handlePageChange={handlePageChange}
                        />
                    </>
                )}

                <CommonModal
                    isOpen={isDrawerOpen}
                    onClose={() => setIsDrawerOpen(false)}
                    animate={true}
                    width={drawerWidth}
                    body={
                        // <Box>{orderData && <OrderDetails orderDetails={orderData} />}</Box>
                        <Box>{orderData && <SdkOrderDetails data={orderData} />}</Box>
                    }
                />
            </Box>
        </>
    );
};

export default SdkOrderTable;
